import { useLoggerOverlay as useLoggerOverlayShared } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { LoggerOverlayData } from '@bcp-channels-sharedcomponents-reactjs/core/dist/types';
import { LoggerConfig } from '@configs';

export const useLoggerOverlay = () => {
	const loggerOverlay = useLoggerOverlayShared();

	const log = (data?: LoggerOverlayData) => {
		const logData: LoggerOverlayData = {
			version: data?.version || LoggerConfig.buildNumber,
			location: data?.location || window.location.origin + window.location.pathname,
			searchParams: window.location.search,
			...data,
		};

		LoggerConfig.debug && loggerOverlay?.showOverlay(logData);
	};

	return { log };
};
